module.exports = __webpack_public_path__ + "media/src/assets/Images/Location-be03262032ce671ed094ef337a31da15.svg";